import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getPrivileges(data) {
    return request.get(`/${platform}/privileges`, data)
}

export function deletePrivileges(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/privileges/${ids}`)
}

export function storeOrUpdatePrivilege(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/privileges/${data.id}` : `/${platform}/privileges`;
    return request[method](url, data)
}
